export function parseSecondaryLink(link: string): string {
    if (typeof window === "undefined") return link

    if (
        link.includes("kirby.familienunternehmen-politik.de/") &&
        window.location.href.includes(".code.testversion.online")
    ) {
        return link.replace("kirby.familienunternehmen-politik.de/", "sfu-politik-2025-kirby.code.testversion.online/")
    }

    return link
}
